import { formatPrice, formatShortDate, joinParts, safeUrl } from '../../../../format'

import style from './style.module.css'

const CourseItem = ({ course }) => {
  const href = safeUrl(course.url)

  const meta = joinParts([
    course.level,
    course.deliveryMode,
    formatPrice(course.price, course.currency, course.isFree),
    formatShortDate(course.startAt),
  ])

  const body = (
    <>
      {course.title && (
        <span className={style.companyModal_position_item_title}>{course.title}</span>
      )}

      {meta && <span className={style.companyModal_position_meta}>{meta}</span>}
    </>
  )

  if (!href) {
    return <div className={style.companyModal_position_item}>{body}</div>
  }

  return (
    <a
      className={`${style.companyModal_position_item} ${style.companyModal_position_item_link}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-log-action="spotlight_open_course"
    >
      {body}
    </a>
  )
}

export default CourseItem
